import { render, staticRenderFns } from "./Testing.vue?vue&type=template&id=33071ae8&scoped=true"
import script from "./Testing.vue?vue&type=script&lang=ts"
export * from "./Testing.vue?vue&type=script&lang=ts"
import style0 from "./Testing.vue?vue&type=style&index=0&id=33071ae8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33071ae8",
  null
  
)

export default component.exports